<template>
  <div class="progress-bar">
    <ProgressBarDesktop :progressState="store.progress" />
    <ProgressBarMobile :progressState="store.progress" />
  </div>
</template>
<script setup>
import { ref, watch } from "vue";
import { gsap, CSSPlugin } from "gsap/all";

import ProgressBarDesktop from "@/components/layout/progress/ProgressBarDesktop.vue";
import ProgressBarMobile from "@/components/layout/progress/ProgressBarMobile.vue";
import { useProgressStore } from "@/stores/progressStore";

gsap.registerPlugin(CSSPlugin);

const store = useProgressStore();

const animateProgressBar = (next) => {
  const activeBackground = document.querySelector(
    ".progress-bar__desktop__el.PENDING .progress-bar__desktop__background"
  );

  const backgroundAnimation = gsap.timeline();

  backgroundAnimation.to(activeBackground, {
    duration: 1,
    y: "110%", // This is lazy – Calculate the actual height + offset
    ease: "power3.inOut",
    clearProps: "all",
    onComplete: () => {
      store.updateToPending(next);
    },
  });
};

watch(
  () => store.progress.verification,
  (verificationProgress) => {
    if (
      verificationProgress === "COMPLETE" &&
      store.progress.identity !== "COMPLETE"
    ) {
      animateProgressBar("identity");
    }
  }
);

watch(
  () => store.progress.identity,
  (identityProgress) => {
    if (
      identityProgress === "COMPLETE" &&
      store.progress.payment !== "COMPLETE"
    ) {
      animateProgressBar("payment");
    }
  }
);
</script>
<style lang="scss">
.progress-bar {
  width: 100%;
  max-width: calc(50rem - (var(--padding-1)));
  margin: 0 auto;
  padding: 0 var(--padding-1) 2.5rem;

  @include breakpoint($min-m) {
    display: flex;
  }
}
</style>
